namespace RedBullMOBILE360.CustomerCare {
    export interface LineTerminationReportRow {
        Id?: number;
        Msisdn?: string;
        IdNumber?: string;
        SellerId?: number;
        Otp?: string;
        TransDate?: string;
        Status?: number;
        BssRequest?: string;
        BssResponse?: string;
        OrderLat?: string;
        OrderLng?: string;
        AgentId?: number;
        AgentUserName?: string;
    }

    export namespace LineTerminationReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'CustomerCare.LineTerminationReport';
        export const deletePermission = 'CustomerCare:LineTerminationReport';
        export const insertPermission = 'CustomerCare:LineTerminationReport';
        export const readPermission = 'CustomerCare:LineTerminationReport';
        export const updatePermission = 'CustomerCare:LineTerminationReport';

        export declare const enum Fields {
            Id = "Id",
            Msisdn = "Msisdn",
            IdNumber = "IdNumber",
            SellerId = "SellerId",
            Otp = "Otp",
            TransDate = "TransDate",
            Status = "Status",
            BssRequest = "BssRequest",
            BssResponse = "BssResponse",
            OrderLat = "OrderLat",
            OrderLng = "OrderLng",
            AgentId = "AgentId",
            AgentUserName = "AgentUserName"
        }
    }
}
